exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sidebar[data-background-color=\"sample\"] {\r\n    background-color: #A9E3E0;\r\n}\r\n\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/mowebdevice/Desktop/Web Project/angular-scrubup/src/app/layout/layout.component.css
// module id = ../../../../../src/app/layout/layout.component.css
// module chunks = main